const initialState = {
  modalDeleteData: {
    emableModel: false,
    message: "",
    enableCancleButton: true,
    enableOkButton: true,
    headerMsg: "",
  },
  modalData: {
    emableModel: false,
    message: "",
    displayMsg: "",
    enableCancleButton: true,
    enableOkButton: true,
    headerMsg: "",
  },
  getUserByPartnerId: [],
  getUserByOrganisationId: [],
  allData: [],
  total: "0",
  allRoles: [],
  sidebarLoading: false,
  tableLoading: false,
  totalPages: 0,
  currentPage: 1,
  totalItems: 0,
  userListRole: [],
  selectedUser: {},
  searchOptions: {},
};
const UserManagementReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "SET_USER_ DATA":
      return {
        ...state,
        allData: payload.content || [],
        currentPage: payload.page,
        totalItems: payload.totalItems,
        totalPages: payload.totalPages,
      };
    case "UPDATE_ROLES_FORM":
      return {
        ...state,
        role_form_data: action.data,
      };
    case "SELECTED_ROLE":
      return {
        ...state,
        selected_role: {
          ...state.selected_role,
          [action.id]: {
            idType: action.idType,
            id: action.id,
            status: action.status,
          },
        },
      };
    case "SELECTED_ROLE_STATUS":
      return {
        ...state,
        selected_role_status: {
          ...state.selected_role_status,
          [action.id]: {
            status: action.status,
          },
        },
      };
    case "CLEAR_SELECTED_ROLE_STATUS":
      return {
        ...state,
        selected_role_status: {},
      };
    case "OPEN_MODEL_DELETE":
      return {
        ...state,
        modalDeleteData: action.value,
      };
    case "ADD_USER":
      return {
        ...state,
        allData: [...state.allData, payload],
      };
    case "UPDATE_USER": {
      const userId = payload.id;
      return {
        ...state,
        allData: state.allData.map((user) => {
          return user.id === userId ? payload : user;
        }),
      };
    }
    case "DELETE_USER": {
      const userId = payload;
      return {
        ...state,
        allData: state.allData.filter((user) => user.id !== userId),
      };
    }
    case "OPEN_MODEL":
      return {
        ...state,
        modalData: action.value,
      };
    // case "GET_USER_DATA_BY_PARTNER_ID":
    //   return {
    //     ...state,
    //     getUserByPartnerId: action.data
    //   }
    case "GET_USER_DATA_BY_ORGANISATION_ID":
      return {
        ...state,
        getUserByOrganisationId: action.data,
      };
    case "FILTER_USER_DATA":
      let value = action.value;
      let filteredData = [];
      if (value.length) {
        filteredData = state.allData.filter((item) => {
          let startsWithCondition =
            item.name.toLowerCase().startsWith(value.toLowerCase()) ||
            item.role.toLowerCase().startsWith(value.toLowerCase()) ||
            item.email.toLowerCase().startsWith(value.toLowerCase());

          let includesCondition =
            item.name.toLowerCase().includes(value.toLowerCase()) ||
            item.role.toLowerCase().includes(value.toLowerCase()) ||
            item.email.toLowerCase().includes(value.toLowerCase());

          if (startsWithCondition) {
            return startsWithCondition;
          } else if (!startsWithCondition && includesCondition) {
            return includesCondition;
          } else return null;
        });
        // .slice(state.params.page - 1, state.params.perPage)
        return {
          ...state,
          filteredData,
        };
      } else {
        filteredData = state.data;
        return { ...state, filteredData };
      }

    case "SET_ALL_ROLES":
      return {
        ...state,
        allRoles: payload,
      };

    case "UPDATE_USER_ICON_PATH_LOCALLY":
      const { id, url } = payload;
      return {
        ...state,
        allData: state.allData.map((user) => {
          return user.id === id ? { ...user, userIconPath: url } : user;
        }),
      };
    case "SET_SIDEBAR_LOADING":
      return {
        ...state,
        sidebarLoading: payload,
      };
    case "SEARCH_USERS":
      return {
        ...state,
        allData: payload.content || [],
        currentPage: payload.page,
        totalItems: payload.totalItems,
        totalPages: payload.totalPages,
      };
    case "USER_LIST_BY_ROLE":
      return {
        ...state,
        userListRole: Array.isArray(payload) ? payload : [],
      };
    case "GET_USER_BY_ID":
      return {
        ...state,
        selectedUser: payload ,
      };
    case "SET_TABLE_LOADING":
      return {
        ...state,
        tableLoading: payload,
      };
    case "SET_SEARCH_OPTIONS":
      return {
        ...state,
        searchOptions: payload,
      };
    default:
      return state;
  }
};

export default UserManagementReducer;
